<template>
  <div class="main">
    <div class="handle-search">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-circle-plus"
        @click="showDialog()"
        >新增SDK账号</el-button
      >
      <!-- <div class="search-box">
        <div class="searchItem">
          <span class="tit">状态：</span>
          <el-select style="width:120px" size="small" v-model="query.filterStatus" clearable  @change="getUserList">
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="停用"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span class="tit">用户名：</span>
          <el-input style="width:160px" size="small" v-model="query.searchText" placeholder="请输入用户名"></el-input>
        </div>
        <div class="searchItem">
          <el-button size="small" type="primary" icon="el-icon-search" @click="getUserList">搜索</el-button>
        </div>
      </div> -->
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      :height="tableHeight"
      @row-click="showDialog"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        label="序号"
        width="100"
        align="center"
        type="index"
      ></el-table-column>
      <el-table-column
        label="SDK名"
        align="center"
        prop="sdkName"
      ></el-table-column>
      <el-table-column
        label="公司名"
        align="center"
        prop="companyName"
      ></el-table-column>
      <el-table-column
        label="ClientID"
        align="center"
        prop="clientId"
      ></el-table-column>
      <el-table-column
        label="clientToken"
        align="center"
        prop="clientToken"
      ></el-table-column>
      <el-table-column
        label="货单号前缀"
        align="center"
        prop="headerStr"
      ></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[20, 50, 100, 200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 新增 -->
    <el-dialog
      :title="dialogTitile"
      :visible.sync="dialogFormVisible"
      width="650px"
    >
      <div class="content">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="货代渠道:">
            <el-select
              v-model="form.SdkCode"
              placeholder="请选择货代渠道"
              style="width: 60%"
            >
              <el-option
                v-for="item in transChannel"
                :key="item.sdkCode"
                :label="item.sdkName"
                :value="item.sdkCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货单号前缀:">
            <el-input
              style="width: 60%"
              v-model="form.HeaderStr"
              placeholder="请输入货单号前缀"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户编码:" v-if="form.SdkCode == 'chukou1'">
            <el-input
              style="width: 60%"
              v-model="form.UserCode"
              placeholder="请输入客户编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="ClientId:" v-if="form.SdkCode == 'K5'">
            <el-input
              style="width: 60%"
              v-model="form.ClientId"
              placeholder="请输入ClientId"
            ></el-input>
          </el-form-item>
          <el-form-item label="ClientToken:" v-if="form.SdkCode == 'K5'">
            <el-input
              style="width: 60%"
              v-model="form.ClientToken"
              placeholder="请输入ClientToken"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetSdkList,
  GetAllTransChannel,
  UserManagerSetTransSdk,
  AdminSetTransSdk,
  GetChukouECallBackUrl,
  GetChukouEClientId,
} from "@/utils/api";
export default {
  data() {
    return {
      dialogFormVisible: false,
      bindShop: false,
      bindRole: false,
      dialogTitile: "新增用户",
      tableData: [],
      roleList: [],
      advList: [],
      shopList: [],
      tableHeight: 0,
      pageTotal: 10,
      UserId: 0,
      query: {
        pageStart: 1,
        limit: 20,
      },
      transChannel: [],
      form: {
        HeaderStr: "",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 135;
    });
  },
  methods: {
    showDialog(item) {
      if (!item) {
        this.dialogTitile = "新增SDK账号";
        this.form = {
          HeaderStr: "",
        };
      } else {
        let data = JSON.parse(JSON.stringify(item));
        this.dialogTitile = "修改SDK账号";
        this.form.ClientId = data.clientId;
        this.form.ClientToken = data.clientToken;
        this.form.HeaderStr = data.headerStr;
        this.form.SdkCode = data.sdkCode;
      }
      this.dialogFormVisible = true;
    },
    updateState(item) {
      UpdateUserStatus({
        UserId: item.userId,
        Status: item.curStatus == 1 ? 0 : 1,
      }).then((res) => {
        this.$message.success("状态更新成功");
        this.getUserList();
      });
    },

    GetAllTransChannel() {
      GetAllTransChannel().then((res) => {
        if (res) {
          this.transChannel = res;
        }
      });
    },
    // 获取用户列表
    getUserList() {
      GetSdkList(this.query).then((res) => {
        this.tableData = res.data;
        this.pageTotal = res.totalData;
      });
    },
    showShop(item) {
      this.bindShop = true;
      this.UserId = item.userId;
      this.shopList = this.shopList.map((item) => {
        return {
          ...item,
          isSelected: false,
        };
      });
      GetAimUserShopList({
        userId: item.userId,
      }).then((res) => {
        res.forEach((v, i) => {
          this.shopList.forEach((v1, i1) => {
            if (v1.shopId == v.shopId) {
              this.$set(this.shopList[i1], "isSelected", true);
            }
          });
        });
      });
    },
    showRole(item) {
      this.bindRole = true;
      this.UserId = item.userId;
      item.roleInfos.forEach((v, i) => {
        this.roleList.forEach((v1, i1) => {
          if (v1.roleId == v.roleId) {
            this.$set(this.roleList[i1], "isSelected", true);
          }
        });
      });
    },
    changeShopState(item) {
      if (!item.isSelected) {
        RemoveShopUserRalation({
          UserId: this.UserId,
          ShopId: item.shopId,
        }).then((res) => {
          this.$message.success("店铺解绑成功");
          this.getUserList();
        });
      } else {
        AddShopUserRalation({
          UserId: this.UserId,
          ShopId: item.shopId,
        }).then((res) => {
          this.$message.success("店铺绑定成功");
          this.getUserList();
        });
      }
    },
    changeRoleState(item) {
      let roleIds = [];
      let userId = this.UserId;
      this.roleList.forEach((v) => {
        if (v.isSelected) {
          roleIds.push(v.roleId);
        }
      });
      SetUserRoles({
        roleIds,
        userId,
      }).then((res) => {
        if (res) {
          this.$message.success("角色设置成功");
          this.getUserList();
        }
      });
    },

    //提交
    submit() {
      let { SdkCode, ClientId, ClientToken, HeaderStr, UserCode } = this.form;

      if (!SdkCode) {
        this.$message.error("请选择SdkCode");
        return;
      }

      if (SdkCode == "K5") {
        if (!ClientId) {
          this.$message.error("请填写ClientId");
          return;
        }

        if (!ClientToken) {
          this.$message.error("请填写ClientToken");
          return;
        }

        let userName = sessionStorage.getItem("userName");

        if (userName == "admin") {
          AdminSetTransSdk({
            CompanyId: sessionStorage.getItem("companyId"),
            ClientId,
            HeaderStr,
            ClientToken,
            SdkCode,
          }).then((res) => {
            if (res) {
              this.$message.success("提交成功");
              this.getUserList();
              this.dialogFormVisible = false;
            }
          });
        } else {
          UserManagerSetTransSdk({
            ClientId,
            HeaderStr,
            ClientToken,
            SdkCode,
          }).then((res) => {
            if (res) {
              this.$message.success("提交成功");
              this.getUserList();
              this.dialogFormVisible = false;
            }
          });
        }
      } else if (SdkCode == "chukou1") {
        if (!UserCode) {
          this.$message.error("请填写客户编码");
          return;
        }

        GetChukouEClientId().then((res) => {
          if (res) {
            var clientid = res;
            GetChukouECallBackUrl().then((res) => {
              var redirectUri = res;
              sessionStorage.setItem("HeaderStr",HeaderStr);
              sessionStorage.setItem("UserCode",UserCode);
              var url = `http://openapi.ck1info.com/oauth2/authorization?client_id=${clientid}&response_type=code&scope=OpenApi&redirect_uri=${redirectUri}`;
             window.open(url, "_blank");
            });
          }
        });
      }
    },
    // 改变分页
    handlePageChange(val) {
      this.query.pageStart = val;
      this.getUserList();
    },
    sizeChange(val) {
      this.query.limit = val;
      this.getUserList();
    },
  },
  components: {},
  created() {
    this.getUserList();
    this.GetAllTransChannel();
  },
};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  .handle-search {
    background: #f3f3f3;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    padding: 10px 20px;
    border-radius: 5px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .search-box {
      display: flex;
      width: 80%;
      justify-content: flex-end;
      .searchItem {
        margin-left: 20px;
        input,
        select {
          width: 160px;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    margin-top: 20px;
  }
  .handle-fun {
    margin: 20px 0;
  }
  .shopList {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding-left: 60px;
    /deep/ .el-checkbox {
      margin-top: 5px;
      margin-bottom: 5px;
      width: 220px;
    }
  }
}
/deep/ .el-table__row {
  cursor: pointer;
}
</style>